export default __webpack_public_path__ + "static/fd70bc7a-8332-4a57-acd3-4f1e199be72c-f5d9c21f21c5e38d8dd79f437a2d87f2.woff";